require('/opt/odin/app/frontend/components/discipline_banner/index.module.scss');
require('/opt/odin/app/frontend/components/discipline_banner/images/background.svg');module.exports = "../../app/cells/components/discipline_banner/show.erb";